import React, { useEffect } from "react";

export const ArsenalHubTermsOfUse = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ background: '#f9fafb', minHeight: '100vh', padding: '60px 20px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        {/* Header Card */}
        <div style={{
          background: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)',
          padding: '50px 40px',
          borderRadius: '16px',
          marginBottom: '40px',
          color: '#fff',
          textAlign: 'center',
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
        }}>
          <i className="fa-solid fa-gavel" style={{ fontSize: '48px', marginBottom: '20px', color: '#94a3b8' }}></i>
          <h1 style={{ fontSize: '36px', marginBottom: '10px', color: '#fff', fontWeight: '700' }}>
            Termos de Uso do ArsenalHub
          </h1>
          <p style={{ color: '#cbd5e1', fontSize: '14px', opacity: '0.9', fontStyle: 'italic', margin: 0 }}>
            Última atualização: Junho de 2026
          </p>
        </div>

        {/* Content Card */}
        <div style={{
          background: '#fff',
          padding: '50px 40px',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          lineHeight: '1.8',
          fontSize: '15px',
          color: '#374151'
        }}>
          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '0',
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            1. Aceitação dos Termos
          </h2>
          <p style={{ textAlign: 'justify', marginBottom: '24px' }}>
            Ao criar uma conta e utilizar o ArsenalHub, você concorda em cumprir e estar vinculado a estes Termos de Uso.
            Se você não concordar com qualquer parte destes termos, não poderá utilizar o aplicativo.
            Estes termos aplicam-se a todos os usuários do aplicativo, incluindo, mas não se limitando a, usuários que são
            apenas navegadores, CACs registrados e administradores.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            2. Elegibilidade
          </h2>
          <p style={{ marginBottom: '15px' }}>O ArsenalHub é destinado exclusivamente a:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>Maiores de 18 anos</li>
            <li style={{ marginBottom: '10px' }}>
              Atiradores, Caçadores e Colecionadores (CACs) devidamente autorizados pela Polícia Federal do Brasil
            </li>
            <li style={{ marginBottom: '10px' }}>
              Pessoas com capacidade legal para celebrar contratos vinculativos
            </li>
          </ul>
          <p style={{ marginBottom: '24px' }}>
            Ao utilizar o serviço, você declara e garante que atende a todos os requisitos de elegibilidade acima.
            Se você não atender a esses requisitos, não poderá acessar ou usar o aplicativo.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            3. Uso do Serviço
          </h2>
          <p style={{ marginBottom: '15px' }}>Você concorda em usar o ArsenalHub apenas para os seguintes propósitos:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>Gerenciar seu acervo de armas de fogo, munições e equipamentos</li>
            <li style={{ marginBottom: '10px' }}>Armazenar e organizar documentos legais (CR, CRAF, GT)</li>
            <li style={{ marginBottom: '10px' }}>Registrar habitualidade em práticas de tiro</li>
            <li style={{ marginBottom: '10px' }}>Manter registros de manutenção e treinamentos</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>Você concorda em NÃO utilizar o aplicativo para:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '24px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>Atividades ilegais ou não autorizadas</li>
            <li style={{ marginBottom: '10px' }}>Violar leis federais, estaduais ou municipais brasileiras</li>
            <li style={{ marginBottom: '10px' }}>Comercialização ilegal de armas ou munições</li>
            <li style={{ marginBottom: '10px' }}>Compartilhar informações de terceiros sem autorização</li>
            <li style={{ marginBottom: '10px' }}>Tentar burlar ou hackear o sistema de segurança</li>
            <li style={{ marginBottom: '10px' }}>Carregar malware, vírus ou código malicioso</li>
          </ul>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            4. Conta de Usuário
          </h2>
          <p style={{ marginBottom: '15px' }}>
            Você é responsável por manter a confidencialidade de suas credenciais de login (email/senha ou Google Sign-In).
            Você concorda em:
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>Fornecer informações verdadeiras e precisas durante o registro</li>
            <li style={{ marginBottom: '10px' }}>Atualizar suas informações caso haja mudanças</li>
            <li style={{ marginBottom: '10px' }}>Manter a segurança de sua conta e senha</li>
            <li style={{ marginBottom: '10px' }}>Notificar-nos imediatamente sobre qualquer uso não autorizado</li>
          </ul>
          <p style={{ marginBottom: '24px' }}>
            Você é totalmente responsável por todas as atividades que ocorrem em sua conta.
            Não nos responsabilizamos por perdas decorrentes de uso não autorizado de sua conta.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            5. Responsabilidades do Usuário
          </h2>
          <p style={{ marginBottom: '15px' }}>Como usuário do ArsenalHub, você é responsável por:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>
              Garantir que possui autorização legal para posse/porte de armas registradas no aplicativo
            </li>
            <li style={{ marginBottom: '10px' }}>Manter documentação atualizada e válida (CR, CRAF, GT)</li>
            <li style={{ marginBottom: '10px' }}>
              Cumprir todas as leis e regulamentos da Polícia Federal sobre armas de fogo
            </li>
            <li style={{ marginBottom: '10px' }}>Não compartilhar informações sensíveis de terceiros</li>
            <li style={{ marginBottom: '10px' }}>Utilizar o aplicativo de forma ética e legal</li>
          </ul>
          <div style={{
            background: '#fef3c7',
            padding: '16px 20px',
            borderLeft: '4px solid #f59e0b',
            borderRadius: '6px',
            marginBottom: '24px'
          }}>
            <strong>
              O ArsenalHub é uma ferramenta de gestão e não substitui o cumprimento de obrigações legais com a Polícia Federal.
            </strong>
          </div>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            6. Propriedade Intelectual
          </h2>
          <p style={{ marginBottom: '15px' }}>
            O ArsenalHub e todo o seu conteúdo, recursos e funcionalidades (incluindo, mas não se limitando a, software,
            código, design, texto, gráficos e logos) são de propriedade exclusiva da equipe do ArsenalHub e são protegidos
            por leis de direitos autorais, marcas registradas e outras leis de propriedade intelectual.
          </p>
          <p style={{ marginBottom: '15px' }}>Você concorda em não:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '24px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>Copiar, modificar ou distribuir o aplicativo ou qualquer parte dele</li>
            <li style={{ marginBottom: '10px' }}>Fazer engenharia reversa ou tentar extrair o código-fonte</li>
            <li style={{ marginBottom: '10px' }}>Remover avisos de propriedade ou marcas registradas</li>
          </ul>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            7. Licença de Uso
          </h2>
          <p style={{ marginBottom: '15px' }}>
            Sujeito ao cumprimento destes Termos, concedemos a você uma licença limitada, não exclusiva, não transferível
            e revogável para:
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>Acessar e usar o ArsenalHub para fins pessoais</li>
            <li style={{ marginBottom: '10px' }}>Baixar e instalar o aplicativo em seus dispositivos pessoais</li>
            <li style={{ marginBottom: '10px' }}>Sincronizar dados entre seus dispositivos</li>
          </ul>
          <p style={{ marginBottom: '24px' }}>
            Esta licença não inclui qualquer direito de revenda ou uso comercial do aplicativo.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            8. Limitações de Responsabilidade
          </h2>
          <p style={{ marginBottom: '15px' }}>
            O ArsenalHub é fornecido "como está" e "conforme disponível", sem garantias de qualquer tipo, expressas ou implícitas.
          </p>
          <p style={{ marginBottom: '15px' }}>Não nos responsabilizamos por:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>Perda de dados devido a falhas técnicas ou erros do usuário</li>
            <li style={{ marginBottom: '10px' }}>Danos decorrentes do uso ou incapacidade de usar o aplicativo</li>
            <li style={{ marginBottom: '10px' }}>Falhas de segurança resultantes de uso inadequado por terceiros</li>
            <li style={{ marginBottom: '10px' }}>Decisões tomadas com base em informações do aplicativo</li>
            <li style={{ marginBottom: '10px' }}>Conformidade legal do usuário com a Polícia Federal</li>
          </ul>
          <p style={{ marginBottom: '24px' }}>
            Em nenhuma hipótese seremos responsáveis por danos indiretos, incidentais, especiais, consequenciais ou punitivos.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            9. Modificações no Serviço
          </h2>
          <p style={{ marginBottom: '24px' }}>
            Reservamos o direito de modificar ou descontinuar, temporária ou permanentemente, o serviço (ou qualquer parte dele)
            com ou sem aviso prévio. Não seremos responsáveis perante você ou terceiros por qualquer modificação, suspensão
            ou descontinuação do serviço.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            10. Cancelamento e Suspensão
          </h2>
          <p style={{ marginBottom: '15px' }}>
            Reservamos o direito de suspender ou encerrar sua conta e acesso ao aplicativo, a nosso exclusivo critério,
            sem aviso prévio ou responsabilidade, por qualquer motivo, incluindo, mas não se limitando a, violação destes Termos.
          </p>
          <p style={{ marginBottom: '24px' }}>
            Você pode cancelar sua conta a qualquer momento através do menu de perfil.
            Após o cancelamento, todos os seus dados serão permanentemente excluídos conforme nossa{' '}
            <a href="/arsenalhub/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: '#334155', fontWeight: '600', textDecoration: 'underline' }}>
              Política de Privacidade
            </a>.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            11. Conformidade Legal
          </h2>
          <p style={{ marginBottom: '15px' }}>
            O usuário declara estar em conformidade com todas as leis aplicáveis, incluindo:
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '24px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>Lei nº 10.826/2003 (Estatuto do Desarmamento)</li>
            <li style={{ marginBottom: '10px' }}>Decreto nº 11.615/2023 (Regulamenta o Estatuto do Desarmamento)</li>
            <li style={{ marginBottom: '10px' }}>Portarias da Polícia Federal sobre CAC</li>
            <li style={{ marginBottom: '10px' }}>LGPD (Lei Geral de Proteção de Dados)</li>
          </ul>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            12. Alterações nos Termos
          </h2>
          <p style={{ marginBottom: '24px' }}>
            Podemos revisar e atualizar estes Termos de Uso periodicamente, a nosso exclusivo critério.
            Todas as mudanças serão efetivas imediatamente após a publicação da versão atualizada nesta página.
            Você concorda em revisar periodicamente estes Termos para estar ciente de quaisquer alterações.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            13. Lei Aplicável
          </h2>
          <p style={{ marginBottom: '24px' }}>
            Estes Termos serão regidos e interpretados de acordo com as leis da República Federativa do Brasil,
            sem considerar conflitos de disposições legais. Qualquer disputa relacionada a estes Termos será
            resolvida nos tribunais brasileiros.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            14. Contato
          </h2>
          <p style={{ marginBottom: '15px' }}>
            Para dúvidas sobre estes Termos de Uso, entre em contato:
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '32px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>
              <strong>Email:</strong> suporte@cortexps.com.br
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Jurídico:</strong> legal@cortexps.com.br
            </li>
          </ul>

          <div style={{
            background: '#dbeafe',
            borderLeft: '4px solid #334155',
            padding: '20px',
            borderRadius: '8px',
            marginTop: '40px'
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <span style={{ fontSize: '24px' }}>⚖️</span>
              <div>
                <strong style={{ fontSize: '15px', display: 'block', marginBottom: '8px', color: '#1e293b' }}>
                  Aceitação
                </strong>
                <p style={{ margin: '0', fontSize: '14px', color: '#475569', lineHeight: '1.6' }}>
                  Ao utilizar o ArsenalHub, você concorda com estes Termos de Uso e nossa{' '}
                  <a href="/arsenalhub/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: '#334155', fontWeight: '600', textDecoration: 'underline' }}>
                    Política de Privacidade
                  </a>.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          marginTop: '40px',
          padding: '30px',
          background: '#1f2937',
          borderRadius: '12px',
          color: '#9ca3af',
          textAlign: 'center',
          fontSize: '13px'
        }}>
          <p style={{ marginBottom: '5px', fontWeight: '600', color: '#cbd5e1' }}>
            © {new Date().getFullYear()} ArsenalHub. Todos os direitos reservados.
          </p>
          <p style={{ marginBottom: '0', fontSize: '12px' }}>
            Este aplicativo é destinado exclusivamente a CACs autorizados pela Polícia Federal do Brasil.
          </p>
        </div>
      </div>
    </div>
  );
};
